import { Map } from 'immutable'
import { get as getConfig } from 'config'

const config = getConfig()
const communityProfileEnabled = !!(config && config.features
  && config.features.communityProfile)

const EMPTY_PICTURE = { url: '', small: '', card: '' }
const EMPTY_MAP = Map()

/**
 * Select a profile picture for a given uid from the GraphQL lookup table.
 *
 * Feature-flag gated:
 *   ON  → returns { url, small, card } (empty strings if not yet loaded)
 *   OFF → returns null (callers use their existing REST paths)
 */
export function selectProfilePicture (state, uid) {
  if (!communityProfileEnabled) return null
  if (!uid) return EMPTY_PICTURE
  const key = String(uid)
  const gql = state.communityProfile.getIn(['profilePictures', 'data', key])
  if (gql && gql.size > 0) {
    return gql.toJS()
  }
  return EMPTY_PICTURE
}

/**
 * Shorthand selector for the current user's profile picture.
 */
export function selectCurrentUserProfilePicture (state) {
  const uid = state.auth.get('uid')
  return selectProfilePicture(state, uid)
}

/**
 * Select the entire profilePictures lookup Map for multi-profile components.
 *
 * Feature-flag gated:
 *   ON  → returns Immutable Map keyed by uid string
 *   OFF → returns empty Map (callers fall back to REST paths)
 */
export function selectProfilePicturesMap (state) {
  if (!communityProfileEnabled) return EMPTY_MAP
  return state.communityProfile.getIn(['profilePictures', 'data'], EMPTY_MAP)
}
